import classNames from 'classnames'
import React, { PropsWithChildren, ReactNode } from 'react'

import { Body2, Heading6 } from '@ui/Typography'
import { IconButton } from '@ui/components/Button'
import { CloseIcon } from '@ui/icons/Close.icon'
import { DummyIcon } from '@ui/icons/Dummy.icon'
import { IconFCType } from '@ui/icons/types'

import styles from './FormTemplate.module.scss'

interface CommandPageTemplateProps {
  title?: string
  subtitle?: string | ReactNode

  goBack?(): void

  contentClassName?: string
  headerDisplayType?: 'grid' | 'flex'
  wrapperClassName?: string

  goBackIcon?: IconFCType
  wrapped?: boolean
  bottomText?: string

  renderIcon?: ReactNode
}

export const FormTemplate: React.FC<PropsWithChildren<CommandPageTemplateProps>> = (props) => {
  const {
    goBackIcon,
    subtitle,
    wrapped,
    children,
    title,
    goBack,
    contentClassName,
    headerDisplayType = 'grid',
    wrapperClassName,
    renderIcon,
  } = props

  return (
    <div
      className={classNames(styles.wrapper, wrapperClassName, {
        [styles.wrapped]: !!wrapped,
      })}
    >
      <div
        className={classNames(styles.title, {
          [styles.grid]: headerDisplayType === 'grid',
          [styles.flex]: headerDisplayType === 'flex',
        })}
      >
        <div className={styles.closeButtonWrapper}>
          {goBack && <IconButton.Ghost icon={goBackIcon ?? CloseIcon} onClick={goBack} />}
        </div>

        {title && <Heading6 medium>{title}</Heading6>}

        <div className={styles.iconWrapper}>{renderIcon || <DummyIcon />}</div>
      </div>
      {!!subtitle && <Body2 className={styles.subtitle}>{subtitle}</Body2>}
      <div
        className={classNames(styles.content, contentClassName, {
          [styles.noWrapper]: !!wrapped,
        })}
      >
        {children}
      </div>
      {!!props.bottomText && <Body2 className='text-align-center'>{props.bottomText}</Body2>}
    </div>
  )
}
